import { documentsModule } from "./documents";
import { accountingModule } from "./accounting";
import { adminModule } from "./admin";
import { billingModule } from "./billing";
import { communicationsModule } from "./communications";
import { eventsModule } from "./events";
import { expensesModule } from "./expenses";
import { guestsModule } from "./guests";
import { importersModule } from "./importers";
import { ledgerModule } from "./ledger";
import { lodgingModule } from "./lodging";
import { membersModule } from "./members";
import { reportsModule } from "./reports";
import { portalModule } from "./portal";
import { posModule } from "./pos";
import { teesheetModule } from "./teesheet";
import { frontdeskModule } from "./frontdesk";
import { notificationsModule } from "./notifications";
import type { ModuleDefinition } from "./types";

/**
 * Every feature module of the staff app, in sidebar order. Point of sale and billing
 * will each add one entry here; nothing else in the shell changes.
 */
export const modules: readonly ModuleDefinition[] = [
  membersModule,
  portalModule,
  teesheetModule,
  guestsModule,
  frontdeskModule,
  communicationsModule,
  posModule,
  lodgingModule,
  eventsModule,
  billingModule,
  accountingModule,
  ledgerModule,
  expensesModule,
  reportsModule,
  documentsModule,
  importersModule,
  notificationsModule,
  adminModule,
];
